module.exports = __webpack_public_path__ + "static/section1-photo2-e15268d3a686969cb1213edd2ca91122.png";